export class BaseLookupInfor {
    CategoryTypeId: number;
    IconUrl: string;
    Id: number;
    NameEN: string;
    NameFR: string;
    NameNL: string;
    ParentId: number;
}

export class ReportUserLookupInfoDto {
    Id: number;
    Name: string;
    ShortName: string;
}

export class ReportTemplateLookupInfoDto extends BaseLookupInfor {
    ID: number;
    TemplateType: number;
    FileName: string;
    ReportType: number;
    EmailAttMethod: number;
    IsActive: boolean;
    PurposeId: number;
    FolderId: number;
    ReportFileModifiedDate: Date;
    FieldsInReport: string;
}

export class ReportTemplateFolderLookupInfoDto extends BaseLookupInfor {
    Id: number;
    ParentId: number;
    DescNL: string;
    DescFR: string;
    DescEN: string;
}
export class ReportPublisherLookupInfoDto extends BaseLookupInfor { }

export class ReportMessageLookupInfoDto {
    Id: number;
    Type: number;
    OrderIndex: number;
    IsUseBaseTemplate: boolean;
    IsFaxSameAsLetter: boolean;
    Attachment1Id: number;
    Attachment2Id: number;
    ShowAddressId: number;
    ShowPriceId: number;
    IsNotEmail1: boolean;
    IsNotEmail2: boolean;
    IsActive: boolean;
    PurposeId: number;
    FolderId: number;
    IsIncludeLinkToProperty: boolean;
    IsRequestDelivery: boolean;
    IsRequestRead: boolean;
    IsTrackEmails: boolean;
    DescNL: string;
    DescFR: string;
    DescEN: string;
}

export class ReportSendEmailUpdateModel {
    Id: number;
    Field: string;
    Value: any;
}

export class ReportMessageFolderLookupInfoDto extends BaseLookupInfor { }
export class ReportMediaLookupInfoDto extends BaseLookupInfor { }
export class ReportEmailLookupInfoDto extends BaseLookupInfor { }
export class ReportEmailServerLookupInfoDto extends BaseLookupInfor { }

export class ReportDocumentModelDto {
    Type: number; // 0 : Property, 1 : Group, 2 : File
    GroupId: number;
    Id: number;
    PropertyId: number
    Name: string;
    DocumentTypeId: number;
    IsIncludeInMail: boolean;
    Module: number;
    IsFolder: boolean;
    Comments?: string;
    Filename?: string;
}
export class SendEmailSmsMessageDto {
    DescEN: string;
    DescFR: string;
    DescNL: string;
}

export class SendEmailOrderInforDto {
    DescEN: string;
    DescFR: string;
    DescNL: string;
}

export interface IDesignedTemplate {
    Value?: string,
    Key?: string,
    Id?: number,
    Children?: IDesignedTemplate[],
}

export class DesignedTemplate implements IDesignedTemplate {
    Value?: string;
    Key?: string;
    Id?: number;
    Children?: IDesignedTemplate[];

    constructor(option: any = {}) {
        this.Value = option.Value || null;
        this.Key = option.Key || null;
        this.Id = option.Id || null;
        this.Children = option.Children || [];
    }
}